import { render, staticRenderFns } from "./EvaluationTab.vue?vue&type=template&id=4e6bc84e&scoped=true&"
import script from "./EvaluationTab.vue?vue&type=script&lang=js&"
export * from "./EvaluationTab.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationTab.vue?vue&type=style&index=0&id=4e6bc84e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6bc84e",
  null
  
)

export default component.exports